import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerExchangeComponent } from './dealer-exchange.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { CustomerBuyComponent } from '../customer/customer-buy/customer-buy.component';
import { NotFoundComponent } from 'src/app/auth/not-found/not-found.component';
import { TransactionStage } from 'src/app/public/common/constants/common-basic-data';

const routes: Routes = [
  { path: '', component: DealerExchangeComponent,
    children: [
      
      { path: 'offer', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.FAVORITE ] }},
      
      { path: 'bookings/received', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }},
      { path: 'bookings/sent', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.DRAFT ] }},
      
      { path: 'ongoing', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.ONGOING ] }},
      { path: 'completed', canActivate: [AuthGuard], component: CustomerBuyComponent, data: { transactionStages: [ TransactionStage.COMPLETED ] }},
      
      { path: '**', component: NotFoundComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerExchangeRoutingModule { }
